import React, { useContext } from 'react'
import { Breadcrumbs, BreadcrumbItem } from "@heroui/react"

import { UserContext } from '../contexts/user-context'
import { menuContainerClass } from '../src/styles'

const menuItemClasses = {
  separator: 'pl pr md:pl-2 md:pr-2',
  item: 'data-[current=false]:text-primary hover:text-primary data-[current=true]:text-primary data-[current=true]:font-bold'
}

const AccountOptions = ({ page }) => {
  const userHook = useContext(UserContext)
  const user = userHook.user
  
  const logout = async () => {
    if (window.Beacon) {
      Beacon('identify', {})
    }
    userHook.requireSignin()
  }

  return <div className={`${menuContainerClass} mb-10`}>
    <Breadcrumbs
      size="lg"
      separator={'|'}
      disableAnimation={true}
      itemClasses={menuItemClasses}>
        <BreadcrumbItem href={`/account`} isCurrent={page === 'account'}>account</BreadcrumbItem>
        {user.organizationId && <BreadcrumbItem href={`/organization`} isCurrent={page === 'organization'}>organization</BreadcrumbItem>}
        {user.organizationId && <BreadcrumbItem href={`/credits`} isCurrent={page === 'credits'}>credits</BreadcrumbItem>}
        {user.organizationId && <BreadcrumbItem href={`/payments`} isCurrent={page === 'payments'}>payments</BreadcrumbItem>}
    </Breadcrumbs>
    
    <div className='flex md:justify-end'>
      <Breadcrumbs
        size="lg"
        separator={'|'}
        disableAnimation={true}
        itemClasses={menuItemClasses}>
          {user.isAdmin && <BreadcrumbItem href={`/houndalytics`} isCurrent={page === 'houndalytics'}>houndalytics</BreadcrumbItem>}
          {user.isAdmin && <BreadcrumbItem href={`/houndmin`} isCurrent={page === 'houndmin'}>houndmin</BreadcrumbItem>}
          <BreadcrumbItem onPressEnd={logout} isCurrent={page === 'logout'}>log out</BreadcrumbItem>
      </Breadcrumbs>
    </div>
  </div>
}

export default AccountOptions
